type FilterFieldType = 'number' | 'string' | 'date' | 'enum';

type NumberOperator = 'eq' | 'neq' | 'gt' | 'lt' | 'exists' | 'not-exists';
type StringOperator = 'eq' | 'neq' | 'contains' | 'exists' | 'not-exists';
type DateOperator =
  | 'last-n-days'
  | 'this-month'
  | 'last-month'
  | 'before'
  | 'after'
  | 'exists'
  | 'not-exists';
type EnumOperator = 'eq' | 'neq';

export type FilterOperator =
  | NumberOperator
  | StringOperator
  | DateOperator
  | EnumOperator;

export type EnumOption = { value: string | number; label: string };

export type FilterFieldKey =
  keyof import('../model/InfluencerList.types').Influencer;

export type FilterFieldConfig = {
  key: FilterFieldKey;
  label: string;
  fieldType: FilterFieldType;
  enumOptions?: EnumOption[];
};

export type FilterRule = {
  id: string;
  field: FilterFieldKey;
  operator: FilterOperator;
  value: string | number | null;
};

export const FILTER_FIELD_CONFIGS: FilterFieldConfig[] = [
  {
    key: 'mode',
    label: 'Mode',
    fieldType: 'enum',
    enumOptions: [
      { value: 2, label: 'Onboarding' },
      { value: 4, label: 'Live' },
      { value: 5, label: 'Run Off' },
      { value: 6, label: 'Deactivated' },
    ],
  },
  {
    key: 'tier',
    label: 'Tier',
    fieldType: 'number',
  },
  {
    key: 'businessModel',
    label: 'Business model',
    fieldType: 'enum',
    enumOptions: [
      { value: 'legacy', label: 'Legacy' },
      { value: 'bundle', label: 'Offer' },
    ],
  },
  {
    key: 'createdAt',
    label: 'Created at',
    fieldType: 'date',
  },
  {
    key: 'publishedAt',
    label: 'Go-live date',
    fieldType: 'date',
  },
  {
    key: 'instagramFollowersCount',
    label: 'Instagram followers',
    fieldType: 'number',
  },
  {
    key: 'profileInstagram',
    label: 'Instagram handle',
    fieldType: 'string',
  },
  {
    key: 'profileTiktok',
    label: 'TikTok handle',
    fieldType: 'string',
  },
  {
    key: 'profileYoutubeChannel',
    label: 'YouTube channel',
    fieldType: 'string',
  },
];

export const OPERATORS_BY_TYPE: Record<FilterFieldType, FilterOperator[]> = {
  number: ['eq', 'neq', 'gt', 'lt', 'exists', 'not-exists'],
  string: ['eq', 'neq', 'contains', 'exists', 'not-exists'],
  date: [
    'last-n-days',
    'this-month',
    'last-month',
    'before',
    'after',
    'exists',
    'not-exists',
  ],
  enum: ['eq', 'neq'],
};

export const OPERATOR_LABELS: Record<FilterOperator, string> = {
  eq: 'equals',
  neq: 'not equals',
  gt: 'greater than',
  lt: 'less than',
  contains: 'contains',
  exists: 'exists',
  'not-exists': 'does not exist',
  'last-n-days': 'in last N days',
  'this-month': 'this month',
  'last-month': 'last month',
  before: 'before',
  after: 'after',
};

export const UNARY_OPERATORS: FilterOperator[] = [
  'exists',
  'not-exists',
  'this-month',
  'last-month',
];
